<template>
  <div>
    <v-dialog
      v-model="isOpen"
      max-width="720"
    >
      <v-card
        class="pa-4"
        v-if="isOpen"
      >
        <page-title value="検食" />
        <div v-if="testingMeal.test" class="my-4">
          <div class="radio-group-wrapper">
            <div class="radio-group-label">味付け</div>
            <v-radio-group class="radio-group" v-model="testingMeal.test.flavor" inline hide-details color="primary">
              <v-radio label="適度" :value="1" ></v-radio>
              <v-radio label="甘い" :value="2" ></v-radio>
              <v-radio label="辛い" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">固さ</div>
            <v-radio-group class="radio-group" v-model="testingMeal.test.texture" inline hide-details color="primary">
              <v-radio label="適度" :value="1" ></v-radio>
              <v-radio label="固い" :value="2" ></v-radio>
              <v-radio label="柔らかい" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">鮮度</div>
            <v-radio-group class="radio-group" v-model="testingMeal.test.freshness" inline hide-details color="primary">
              <v-radio label="新鮮" :value="1" ></v-radio>
              <v-radio label="良い" :value="2" ></v-radio>
              <v-radio label="悪い" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">盛り付け</div>
            <v-radio-group class="radio-group" v-model="testingMeal.test.arrangement" inline hide-details color="primary">
              <v-radio label="綺麗" :value="1" ></v-radio>
              <v-radio label="普通" :value="2" ></v-radio>
              <v-radio label="悪い" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">色</div>
            <v-radio-group class="radio-group" v-model="testingMeal.test.color" inline hide-details color="primary">
              <v-radio label="綺麗" :value="1" ></v-radio>
              <v-radio label="普通" :value="2" ></v-radio>
              <v-radio label="悪い" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">分量</div>
            <v-radio-group class="radio-group" v-model="testingMeal.test.quantity" inline hide-details color="primary">
              <v-radio label="適度" :value="1" ></v-radio>
              <v-radio label="多い" :value="2" ></v-radio>
              <v-radio label="少ない" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">異物</div>
            <v-radio-group class="radio-group" v-model="testingMeal.test.hasNoForeignMatter" inline hide-details color="primary">
              <v-radio label="なし" :value="true" ></v-radio>
              <v-radio label="あり" :value="false" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">加熱</div>
            <v-radio-group class="radio-group" v-model="testingMeal.test.hasProperHeat" inline hide-details color="primary">
              <v-radio label="適切" :value="true" ></v-radio>
              <v-radio label="不適切" :value="false" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">異臭</div>
            <v-radio-group class="radio-group" v-model="testingMeal.test.hasNoOdor" inline hide-details color="primary">
              <v-radio label="なし" :value="true" ></v-radio>
              <v-radio label="あり" :value="false" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">異味</div>
            <v-radio-group class="radio-group" v-model="testingMeal.test.hasProperTaste" inline hide-details color="primary">
              <v-radio label="なし" :value="true" ></v-radio>
              <v-radio label="あり" :value="false" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">備考</div>
            <v-textarea v-model="testingMeal.test.note" variant="outlined" hide-details color="primary" />
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">検食実施者</div>
            <v-select
              variant="outlined"
              :items="staffOptions"
              item-value="userId"
              item-title="name"
              v-model="updatingTestedBy"
              hide-details
              color="primary"
            ></v-select>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">検食実施時刻</div>
            <v-text-field type="datetime-local" v-model="updatingTestedAt" variant="outlined" hide-details density="compact" color="primary"/>
          </div>

          <v-progress-linear v-if="isUpdating" indeterminate class="my-4" color="primary" />

          <div class="d-flex my-4">
            <v-spacer />
            <v-btn
              color="primary"
              variant="flat"
              class="mx-4"
              size="large"
              :disabled="isUpdating"
              @click="updateTest"
            >検食を更新</v-btn>
            <v-spacer />
          </div>
        </div>

        <div v-else class="my-4">
          <div class="radio-group-wrapper">
            <div class="radio-group-label">味付け</div>
            <v-radio-group class="radio-group" v-model="flavor" inline hide-details color="primary">
              <v-radio label="適度" :value="1" ></v-radio>
              <v-radio label="甘い" :value="2" ></v-radio>
              <v-radio label="辛い" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">固さ</div>
            <v-radio-group class="radio-group" v-model="texture" inline hide-details color="primary">
              <v-radio label="適度" :value="1" ></v-radio>
              <v-radio label="固い" :value="2" ></v-radio>
              <v-radio label="柔らかい" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">鮮度</div>
            <v-radio-group class="radio-group" v-model="freshness" inline hide-details color="primary">
              <v-radio label="新鮮" :value="1" ></v-radio>
              <v-radio label="良い" :value="2" ></v-radio>
              <v-radio label="悪い" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">盛り付け</div>
            <v-radio-group class="radio-group" v-model="arrangement" inline hide-details color="primary">
              <v-radio label="綺麗" :value="1" ></v-radio>
              <v-radio label="普通" :value="2" ></v-radio>
              <v-radio label="悪い" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">色</div>
            <v-radio-group class="radio-group" v-model="color" inline hide-details color="primary">
              <v-radio label="綺麗" :value="1" ></v-radio>
              <v-radio label="普通" :value="2" ></v-radio>
              <v-radio label="悪い" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">分量</div>
            <v-radio-group class="radio-group" v-model="quantity" inline hide-details color="primary">
              <v-radio label="適度" :value="1" ></v-radio>
              <v-radio label="多い" :value="2" ></v-radio>
              <v-radio label="少ない" :value="3" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">異物</div>
            <v-radio-group class="radio-group" v-model="hasNoForeignMatter" inline hide-details color="primary">
              <v-radio label="なし" :value="true" ></v-radio>
              <v-radio label="あり" :value="false" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">加熱</div>
            <v-radio-group class="radio-group" v-model="hasProperHeat" inline hide-details color="primary">
              <v-radio label="適切" :value="true" ></v-radio>
              <v-radio label="不適切" :value="false" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">異臭</div>
            <v-radio-group class="radio-group" v-model="hasNoOdor" inline hide-details color="primary">
              <v-radio label="なし" :value="true" ></v-radio>
              <v-radio label="あり" :value="false" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">異味</div>
            <v-radio-group class="radio-group" v-model="hasProperTaste" inline hide-details color="primary">
              <v-radio label="なし" :value="true" ></v-radio>
              <v-radio label="あり" :value="false" ></v-radio>
            </v-radio-group>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">備考</div>
            <v-textarea v-model="note" variant="outlined" hide-details color="primary" />
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">検食実施者</div>
            <v-select
              variant="outlined"
              :items="staffOptions"
              item-value="userId"
              item-title="name"
              v-model="testedBy"
              hide-details
              color="primary"
            ></v-select>
          </div>
          <div class="radio-group-wrapper">
            <div class="radio-group-label">検食実施時刻</div>
            <v-text-field type="datetime-local" v-model="testedAt" variant="outlined" hide-details density="compact" color="primary" />
          </div>

          <v-progress-linear v-if="isCreating" indeterminate class="my-4" color="primary" />

          <div class="d-flex my-4">
            <v-spacer />
            <v-btn
              color="primary"
              variant="flat"
              size="large"
              :disabled="!isCreationValid || isCreating"
              @click="createTest"
            >検食を作成</v-btn>
            <v-spacer />
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { foodMenuTestModule } from '@/store/viewModules/food-menu/foodMenuTestModule';

import PageTitle from '@/components/atoms/PageTitle.vue';
import { foodMenusModule } from '@/store/viewModules/food-menu/foodMenusModule';
import { nurseryUserModule } from '@/store/dataModules/nurseryUserModule';
import dayjs from 'dayjs';

interface DataType {
  flavor: number | null;
  texture: number | null;
  freshness: number | null;
  arrangement: number | null;
  color: number | null;
  quantity: number | null;
  hasNoForeignMatter: boolean | null;
  hasProperHeat: boolean | null;
  hasNoOdor: boolean | null;
  hasProperTaste: boolean | null;
  note: string;
  testedBy: number | null;
  testedAt: string | null;

  isCreating: boolean;
  isUpdating: boolean;
}

export default defineComponent({
  components: {
    PageTitle,
  },

  data: (): DataType => ({
    flavor: 1,
    texture: 1,
    freshness: 1,
    arrangement: 1,
    color: 1,
    quantity: 1,
    hasNoForeignMatter: true,
    hasProperHeat: true,
    hasNoOdor: true,
    hasProperTaste: true,
    note: '',
    testedBy: null,
    testedAt: null,

    isCreating: false,
    isUpdating: false,
  }),

  watch: {
    updatingTestedAt: {
      handler(value: string) {
        nurseryUserModule.listStaffs({ date: value, diaryId: this.testingMeal?.test?.testId, diaryType: 'Test' });
        return
      }
    },
    testedAt: {
      handler(value: string) {
        nurseryUserModule.listStaffs({ date: value, diaryId: this.testingMeal?.test?.testId, diaryType: 'Test' });
        return
      }
    },
  },
  
  computed: {
    // ⭕️ 修正5: isDialogOpen を v-model に対応させるため、get と set を用意する
    isOpen: {
      get(): boolean {
        return !!foodMenuTestModule.testingMeal;
      },
      set(val: boolean) {
        if (!val) {
          this.close();
        }
      }
    },
    testingMeal() {
      // Storeのデータが null の場合は、エラー回避用のダミーオブジェクトを返す
      return foodMenuTestModule.testingMeal || {
        planId: 0,
        test: null
      };
    },
    isCreationValid() {
      if (
        this.flavor
        && this.texture
        && this.freshness
        && this.arrangement
        && this.color
        && this.quantity
        && this.hasNoForeignMatter
        && this.hasProperHeat
        && this.hasNoOdor
        && this.hasProperTaste
        && this.testedBy
        && this.testedAt
        && this.note.length > 0
      ) {
        return true;
      }
      return false;
    },
    staffOptions() {
      return nurseryUserModule.staffs.filter(s => !s.isHidden).map((staff) => {
        return {
          userId: staff.userId,
          name: `${staff.lastName} ${staff.firstName}`
        }
      });
    },
    updatingTestedAt: {
      get(): string | null {
        if (
          this.testingMeal
          && this.testingMeal.test
          && this.testingMeal.test.testedAt
        ) {
          return dayjs(this.testingMeal.test.testedAt).format('YYYY-MM-DDTHH:mm')
        }
        return null;
      },
      set(datetime: string) {
        if (
          this.testingMeal
          && this.testingMeal.test
        ) {
          this.testingMeal.test.testedAt = datetime
        }
      }
    },
    updatingTestedBy: {
      get(): number | null {
        if (!this.testingMeal || !this.testingMeal.test || !this.testingMeal.test.testedBy) {
          return null;
        }
        // APIからオブジェクトで降ってきても、IDだけを抽出して返す！
        if (typeof this.testingMeal.test.testedBy === 'object') {
          return this.testingMeal.test.testedBy.userId;
        }
        return this.testingMeal.test.testedBy;
      },
      set(userId: number) {
        if (this.testingMeal && this.testingMeal.test) {
          // 選ばれたIDをセットする
          this.testingMeal.test.testedBy = userId as any; 
        }
      }
    }
  },

  methods: {
    close() {
      foodMenuTestModule.setTestingMeal(null);
    },
    async createTest() {
      if (
        this.testingMeal
        && this.flavor
        && this.texture
        && this.freshness
        && this.arrangement
        && this.color
        && this.quantity
        && this.hasNoForeignMatter
        && this.hasProperHeat
        && this.hasNoOdor
        && this.hasProperTaste
        && this.testedBy
        && this.testedAt
      ) {
        this.isCreating = true;
        const response = await foodMenuTestModule.createTest({
          planId: this.testingMeal.planId,
          flavor: this.flavor,
          texture: this.texture,
          freshness: this.freshness,
          arrangement: this.arrangement,
          color: this.color,
          quantity: this.quantity,
          hasNoForeignMatter: this.hasNoForeignMatter,
          hasProperHeat: this.hasProperHeat,
          hasNoOdor: this.hasNoOdor,
          hasProperTaste: this.hasProperTaste,
          note: this.note,
          testedBy: this.testedBy,
          testedAt: dayjs(this.testedAt).toISOString(),
        });

        if (response) {
          foodMenusModule.replaceMenu(response);
        }

        this.isCreating = false;
        this.close();
      }
    },
    async updateTest() {
      if (
        this.testingMeal
        && this.testingMeal.test
      ) {
        this.isUpdating = true;

        const testedById = typeof this.testingMeal.test.testedBy === 'object' 
                           ? this.testingMeal.test.testedBy.userId 
                           : this.testingMeal.test.testedBy;

        const response = await foodMenuTestModule.updateTest({
          testId: this.testingMeal.test.testId,
          flavor: this.testingMeal.test.flavor,
          texture: this.testingMeal.test.texture,
          freshness: this.testingMeal.test.freshness,
          arrangement: this.testingMeal.test.arrangement,
          color: this.testingMeal.test.color,
          quantity: this.testingMeal.test.quantity,
          hasNoForeignMatter: this.testingMeal.test.hasNoForeignMatter,
          hasProperHeat: this.testingMeal.test.hasProperHeat,
          hasNoOdor: this.testingMeal.test.hasNoOdor,
          hasProperTaste: this.testingMeal.test.hasProperTaste,
          note: this.testingMeal.test.note || ' ',
          testedBy: testedById,
          testedAt: this.testingMeal.test.testedAt,
        });

        if (response) {
          foodMenusModule.replaceMenu(response);
        }

        this.isUpdating = false;
        this.close();
      }
    },
  },

  mounted() {
    this.testedAt = dayjs().format('YYYY-MM-DDTHH:mm');
    nurseryUserModule.listStaffs({ date: this.testedAt, diaryId: this.testingMeal?.test?.testId, diaryType: 'Test' });
  }
});
</script>

<style lang="scss" scoped>
.radio-group-wrapper {
  display: grid;
  grid-template-columns: 120px 1fr;
  align-items: center;

  padding: 8px 0;
  border-bottom: solid 1px #e0e0e0;
  border-top: solid 1px #e0e0e0;

  &:hover {
    background-color: #f0f0f0;
  }
}

.radio-group-label {
  font-weight: bold;
  font-size: 14px;
  
  padding-left: 8px;
}

.radio-group {
  margin: 0;
}
</style>